<template>
    <el-button class="x-button x-button-cancel"
               @click.prevent="clickDownload"
               v-loading="loading">{{ text }}</el-button>
</template>

<script>

export default {
    name: 'XButtonDownload',
    props: {
        resource: {
            type: String
        },
        text: {
            type: String,
            default: 'Descargar'
        },
        externalId: {
            type: String
        },
        filename: {
            type: String
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods :{
        async clickDownload() {
            this.loading = true;
            await this.$http({
                url: `/${this.resource}/download`,
                method: 'POST',
                responseType: 'blob',
                data: {
                    'external_id': this.externalId,
                    'type': this.type
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = this.filename + '_' + moment().format('YYYYMMDDHHmmss')
                    if (this.type === 'pdf') {
                        link.setAttribute('download', fileName + '.pdf');
                    } else {
                        link.setAttribute('download', fileName + '.xlsx');
                    }
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.errors = error;
                });
            this.loading = false;
        },
    }
}
</script>
